import { format } from "date-fns";
import dayjs from "dayjs";


export const showHyphen=(value:any)=>{
    if(value===null ||
        value===undefined ||
        value === "" ||
        value ==="null"){
            return "-";
        }
        return value

}


export const formttedDate = (date: any) => {
  if (!date) return "-";
  return  format(new Date(date), "dd MMM yyyy hh:mm a");
};


































  